import Vue from "vue";
import VueRouter from "vue-router";
import App from "@/App.vue";
import ViewerSearch from "@/components/ViewerSearch.vue";

Vue.use(VueRouter);

// 數值鷹架專用的網址保護資料，不影響既有登入與其他模式。
const NUMERICAL_ROUTE_QUERY_STORAGE_KEY = "numerical-route-query";

function readNumericalRouteQuery() {
  try {
    const query = JSON.parse(
      sessionStorage.getItem(NUMERICAL_ROUTE_QUERY_STORAGE_KEY) || "{}"
    );
    return String(query.mode || "").toLowerCase() === "numerical" ? query : {};
  } catch (error) {
    return {};
  }
}

function getProtectedNumericalQuery(to, from) {
  if (!["/login", "/chat"].includes(to.path)) return null;

  const targetQuery = to.query || {};
  const previousQuery = from.query || {};
  const storedQuery = readNumericalRouteQuery();
  const numericalQuery =
    String(previousQuery.mode || "").toLowerCase() === "numerical"
      ? previousQuery
      : storedQuery;

  if (String(numericalQuery.mode || "").toLowerCase() !== "numerical") {
    return null;
  }

  const numericalCh = String(numericalQuery.ch || "").trim();
  const targetCh = String(targetQuery.ch || "").trim();
  if (numericalCh && targetCh && numericalCh !== targetCh) return null;

  const protectedQuery = {
    ...numericalQuery,
    ...targetQuery,
    mode: "numerical",
  };
  const needsProtection = Object.keys(protectedQuery).some(
    (key) => String(targetQuery[key] ?? "") !== String(protectedQuery[key] ?? "")
  );

  return needsProtection ? protectedQuery : null;
}

const router = new VueRouter({
  mode: "hash",
  routes: [
    { path: "/", redirect: "/login" },
    { path: "/login", component: App },
    { path: "/chat", component: App, meta: { requiresAuth: true } },
    { path: "/viewer", component: ViewerSearch, meta: { requiresAuth: true } },
  ],
});

// 額外註冊保護層；下方既有的登入驗證 guard 保持原樣。
router.beforeEach((to, from, next) => {
  if (String(to.query?.mode || "").toLowerCase() === "numerical") {
    sessionStorage.setItem(
      NUMERICAL_ROUTE_QUERY_STORAGE_KEY,
      JSON.stringify({ ...to.query, mode: "numerical" })
    );
  }

  const protectedQuery = getProtectedNumericalQuery(to, from);
  if (protectedQuery) {
    return next({ path: to.path, query: protectedQuery, replace: true });
  }

  next();
});

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresAuth) return next();

  const isNumericalPreview =
    to.path === "/chat" &&
    String(to.query?.mode || "").toLowerCase() === "numerical" &&
    Boolean(String(to.query?.previewKey || "").trim());

  if (isNumericalPreview) {
    return next();
  }

  const token = localStorage.getItem("session_token");
  if (!token) {
    const loginQuery = {};
    if (to.query.ch) loginQuery.ch = to.query.ch;
    if (to.query.room) loginQuery.room = to.query.room;
    if (to.query.doc) loginQuery.doc = to.query.doc;
    if (String(to.query.ref || "").toLowerCase() === "noai") {
      loginQuery.ref = "noai";
      ["ch1", "ch2", "ch3"].forEach((key) => {
        if (to.query[key]) loginQuery[key] = to.query[key];
      });
    }
    return next({ path: "/login", query: loginQuery });
  }
  next();
});

export default router;
